import { Construction } from "lucide-react";
import PennText from "@/components/ui/text/PennText";

export const PlaceholderPage = ({ title }: { title: string }) => (
  <div className="flex flex-col items-center justify-center h-64 gap-3">
    <div className="w-12 h-12 rounded-2xl bg-white/10 dark:bg-gray-800 flex items-center justify-center">
      <Construction size={22} className="text-on-navy-secondary" />
    </div>
    <div className="text-center">
      <PennText as="h3" size="xl" font="semibold" color="on-navy">{title}</PennText>
      <PennText as="p" size="base" color="on-navy-secondary" className="mt-1">This section is coming soon.</PennText>
    </div>
  </div>
);
